import { render, staticRenderFns } from "./BannerRose.vue?vue&type=template&id=3e464155&scoped=true&"
import script from "./BannerRose.vue?vue&type=script&lang=js&"
export * from "./BannerRose.vue?vue&type=script&lang=js&"
import style0 from "./BannerRose.vue?vue&type=style&index=0&id=3e464155&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e464155",
  null
  
)

export default component.exports